"use client"
import css from "@css/modules/HottestDeals.module.scss"
import { useDealsContext } from "./context"
import cn from "classnames"
import { Select } from "antd"
import { ArrowDown } from "@css/icons/SVG"
import React from "react"
import { useUser } from "@lib/api/user"

const menuMap = new Map([
    [
        2,
        {
            time: 2,
            text: "Top Deals Past 48 Hours"
        }
    ],
    [
        7,
        {
            time: 7,
            text: "Top Deals 7 Days"
        }
    ],
    [
        30,
        {
            time: 30,
            text: "Top Deals 30 Days"
        }
    ],
    [
        60,
        {
            time: 60,
            text: "Top Deals 60 Days"
        }
    ]
])

export function DealsNavigation() {
    const { time, setState } = useDealsContext()
    const { isAuthenticated } = useUser()
    return (
        <div className={css.navigation}>
            {[...menuMap.values()].map((i) => (
                <div key={i.time} className={cn(css.item, time === i.time && css.active)} onClick={() => isAuthenticated && setState({ time: i.time })}>
                    {i.text}
                </div>
            ))}
            <Select
                onChange={(e: number) => isAuthenticated && setState({ time: e })}
                className={cn(css.select, css.mobileNavigation)}
                value={time}
                options={[...menuMap.values()]?.map((i) => {
                    return { value: i.time, label: i.text }
                })}
                dropdownMatchSelectWidth
                virtual={false}
                listHeight={400}
                showArrow
                maxTagCount={1}
                maxTagTextLength={18}
                maxTagPlaceholder={(c) => "+" + c.length}
                tagRender={(props) => <div>{props.label}</div>}
                suffixIcon={<ArrowDown />}
            />
        </div>
    )
}
